export const croTypeNames = [
  'client relations officer',
  'client relations associate',
  'client relation officer',
  'associate academic mentor',
  'senior program officer-ecpc',
  'senior program officer',
  'senior program officer - ecpc',
  'reacquisitions associate',
  'client acquisitions associate',
  'client acquisitions intern',
  'client acquisition associate',
  'senior client acquisitions officer',
  'senior client acquisition officer',
  'client relations manager',
  'senior client relations officer',
];
export const ogaTypeNames = [
  'operations growth associate',
  'operations growth trainee',
  'operations growth associate trainee',
  'operations growth officer',
  'senior operations growth officer',
];

export const crmTypes = ['client relations manager', 'senior client relations officer', 'senior program officer' , 'senior program officer-ecpc' , 'senior program officer - ecpc', 'senior client acquisitions officer', 'client service manager', 'senior client acquisition officer'];

export const sogoTypes = ['senior operations growth officer'];

export const smeAndSmoTypes = [
  'Subject Matter Officer',
  'Subject Expert',
  'Officer- Subject Matter Expertise',
  'Associate- Subject Matter Expertise',
  'Subject Matter Expertise',
];
